import { render } from "./ActionsMessageHeaderFilters.vue?vue&type=template&id=23da5760&scoped=true"
import script from "./ActionsMessageHeaderFilters.vue?vue&type=script&lang=js"
export * from "./ActionsMessageHeaderFilters.vue?vue&type=script&lang=js"

import "./ActionsMessageHeaderFilters.vue?vue&type=style&index=0&id=23da5760&lang=scss&scoped=true"
import "./ActionsMessageHeaderFilters.vue?vue&type=style&index=1&id=23da5760&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23da5760"]])

export default __exports__